import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  indexedPagesController: [
    'runtimeConstant',
    '$scope',
    '$rootScope',
    'dashboardService',
    '$filter',
    '$state',
    'EXT_ICONS',
    '$sce',
    function (
      runtimeConstant,
      $scope,
      $rootScope,
      dashboardService,
      $filter,
      $state,
      EXT_ICONS,
      $sce
    ) {
      'use strict';

      function sortOperation(a, b, column) {
        var res = 0;

        switch (column.type) {
          case 'text':
            res = sortText(a, b, column);
            break;
          case 'number':
            res = sortNumber(a, b, column);
            break;
          case 'date':
            res = sortDate(a, b, column);
            break;
        }
        if (column.sorted === 'desc') return res * -1;

        return res;
      }

      function sortText(a, b, column) {
        if (column.sortExpression !== undefined) {
          var sort1 = $filter('reflect')(a, column.sortExpression);
          var sort2 = $filter('reflect')(b, column.sortExpression);

          if (sort1 === undefined) sort1 = '';
          if (sort2 === undefined) sort2 = '';
          return sort1.toString().localeCompare(sort2);
        } else {
          var value1 = $filter('reflect')(a, column.expression);
          var value2 = $filter('reflect')(b, column.expression);

          if (value1 === undefined) value1 = '';
          if (value2 === undefined) value2 = '';
          return value1.toString().localeCompare(value2);
        }
      }

      function sortNumber(a, b, column) {
        return column.sortExpression !== undefined
          ? $filter('reflect')(a, column.sortExpression) -
              $filter('reflect')(b, column.sortExpression)
          : $filter('reflect')(a, column.expression) -
              $filter('reflect')(b, column.expression);
      }

      function sortDate(a, b, column) {
        var firstDate, secDate;

        if (column.sortExpression !== undefined) {
          firstDate = $filter('reflect')(a, column.sortExpression);
          secDate = $filter('reflect')(b, column.sortExpression);
        } else {
          firstDate = $filter('reflect')(a, column.expression);
          secDate = $filter('reflect')(b, column.expression);
        }
        var firstSplit = firstDate.split('/');
        var secSplit = secDate.split('/');
        firstDate = Date.parse(
          firstSplit[2] + '-' + firstSplit[1] + '-' + firstSplit[0]
        );
        secDate = Date.parse(
          secSplit[2] + '-' + secSplit[1] + '-' + secSplit[0]
        );
        if (firstDate > secDate) return 1;
        if (firstDate < secDate) return -1;
      }

      function loadUsers() {
        dashboardService.getUsersFilter().then((res) => {
          $scope.users = res;
        });
      }

      function loadRepositories() {
        dashboardService.getRepositoriesFilter().then((res) => {
          $scope.repositories = res;
        });
      }

      function isDateField() {
        return $scope.filterByDate;
      }

      function showUsersField() {
        return $scope.filterByUser;
      }

      function isBetweenDates() {
        if (!$scope.newForm.dateFilter) return false;
        if (!$scope.newForm.dateFilter.$modelValue) return false;
        var dateFilter = $scope.newForm.dateFilter.$modelValue.value;
        return $scope.isDateField && dateFilter === 3;
      }

      function isListField() {
        return (
          $scope.additionalField && $scope.additionalField.idFieldType === 7
        );
      }

      function formatedDate(date) {
        if (date === undefined) return '-';
        if (!date.contains('T')) return date;
        var result = new Date(Date.parse(date));
        return result.format('dd/mm/yyyy');
      }

      function getIcon(extension) {
        var ext = extension;

        if (ext.toLowerCase().endsWith('p7s')) {
          var splited = ext.split('.');
          ext = splited[0];
        }

        var image =
          '<img src="/assets/images/file_extensions/default.png" ></img>';
        if (ext !== null && EXT_ICONS.indexOf(ext.toLowerCase()) >= 0) {
          var pngAdjust = ext === 'png' ? 'style="padding-bottom:1px"' : '';
          image =
            '<img src="/assets/images/file_extensions/' +
            ext +
            '.png" onerror="this.src=\'/assets/images/file_extensions/default.png\';" width="18px" ' +
            pngAdjust +
            ' ></img>';
        }

        if (this.isSigned) {
          image +=
            '<img class="signed_doc" src="/assets/images/document_status/seal.png" width="10px"></img>';
        }

        if (this.hasLinkedDocuments === true) {
          image +=
            '<img class="linked_doc" src="/assets/images/document_status/linked.png" width="10px"></img>';
        }

        return $sce.trustAsHtml(image); //Show default icon when the extension icon not exists;
      }

      function formatedSize(size) {
        var sizes = ['B', 'KB', 'MB', 'GB'];
        var len = size;
        var order = 0;
        while (len >= 1024 && order + 1 < sizes.length) {
          order++;
          len = len / 1024;
        }

        if (len !== undefined && len !== null) {
          return len.toFixed(2).toString() + ' ' + sizes[order];
        }

        return '0 KB';
      }

      function formatedDocumentType(name) {
        return $filter('truncate')(name, 30, '...', true);
      }

      function formatedTitle(title) {
        return $scope.truncateText(title, 40);
      }

      function truncateText(string, targetCharacterLength) {
        //preciso calcular o tamanho que as tags bold estao ocupando para ficar tudo com tamanho padrao
        targetCharacterLength +=
          (string.substr(0, 60).split('<b>').length - 1) * 3;
        targetCharacterLength +=
          (string.substr(0, 60).split('</b>').length - 1) * 3;

        var length = string.length;
        if (length < targetCharacterLength) {
          return string;
        } else {
          var shortenedString = string.slice(0, targetCharacterLength);
          var tempshortenedString = shortenedString.slice(
            0,
            shortenedString.lastIndexOf(' ')
          );

          var lastMarkupBegin = -1;
          var lastMarkupEnds = -1;
          try {
            lastMarkupBegin = tempshortenedString.lastIndexOf('<b>');
            lastMarkupEnds = tempshortenedString.lastIndexOf('<');
          } catch {}
          if (lastMarkupBegin !== -1) {
            // has an opening anchor tag
            if (lastMarkupEnds === -1) {
              // not having an closing tag
              tempshortenedString = tempshortenedString.slice(
                0,
                lastMarkupBegin
              );
              return tempshortenedString + '... ';
            }
          }

          var idx = shortenedString.lastIndexOf('<');
          var endTag = shortenedString.length - 4;
          if (idx >= endTag) {
            //aqui removemos o final da string caso ela tenha a abertura de alguma tag html
            shortenedString = shortenedString.substr(0, idx);
          }
          //se foi diminuido o tamanho da string comparado a original, então vou colocar tres pontos indicando que o titulo tem mais conteudo
          return shortenedString.length >= length - 4
            ? shortenedString
            : shortenedString + '... ';
        }
      }

      function formatedDescription(description) {
        var result = description ? description : '';
        return result;
      }

      function sortColumn(column) {
        if (column.sortable !== true) return;

        column.sorted = column.sorted === 'asc' ? 'desc' : 'asc';

        var sort = function (a, b) {
          return sortOperation(a, b, column);
        };
        $scope.revisions = $scope.revisions.sort(sort);

        var unsorted = $scope.columns.filter(function (c) {
          return c.id !== column.id;
        });

        unsorted.forEach(function (c) {
          c.sorted = undefined;
        });
      }

      function saveAsPdf() {
        var filter = {};
        filter.ReportType = 0;
        filter.NoDate = true;
        filter.NoFilter = true;

        if ($scope.selectedUser) {
          filter.NoFilter = false;
          filter.IdUser = $scope.selectedUser.Id;
        }
        if ($scope.selectedRepository) {
          filter.NoFilter = false;
          filter.IdFolder = $scope.selectedRepository.Id;
        }

        if ($scope.isDateField()) {
          filter.NoFilter = false;
          filter.NoDate = false;
          var dateFilter = $scope.newForm.dateFilter.$modelValue.value;
          filter.dateFilterType = dateFilter;
          if ($scope.isBetweenDates()) {
            filter.startDate = $scope.newForm.startDate.$modelValue;
            filter.endDate = $scope.newForm.endDate.$modelValue;
          }
        }

        $scope.revisions = [];
        swal.fire({
          title: $filter('translate')('WAIT GENERATING REPORT'),
          icon: 'info',
          showConfirmButton: false,
          showCancelButton: false,
        });
        $scope.filter = filter;
        dashboardService
          .generateIndexedPagesReport($scope.filter)
          .then((res) => {
            if (res.size !== 0) {
              var url = URL.createObjectURL(res);
              window.open(url);
              swal.close();
            } else {
              swal.fire({
                title: 'Relatório em branco',
                text: 'Não existem dados para serem exibidos neste relatório com os filtros selecionados.',
                icon: 'error',
                showCancelButton: false,
                confirmButtonText: $filter('translate')('OK'),
              });
            }
          })
          .catch((error) => {
            swal.fire({
              title: error.title,
              text: error.text,
              icon: 'error',
              showCancelButton: false,
              confirmButtonText: $filter('translate')('OK'),
            });
          });
      }

      function onSelectUser(value) {
        if (arguments.length === 0) return $scope.selectedUser;
        $scope.value = '';
        $scope.selectedUser = value;
        $scope.revisions = [];
      }

      function onSelectRepository(value) {
        if (arguments.length === 0) return $scope.selectedRepository;
        $scope.value = '';
        $scope.selectedRepository = value;
        $scope.revisions = [];
      }

      function run() {
        try {
          $scope.filter;
          $scope.revisions = [];
          $scope.columns = [];

          $scope.numberFilters = [
            {
              key: '=',
              value: 0,
            },
            {
              key: '>=',
              value: 1,
            },
            {
              key: '<=',
              value: 2,
            },
          ];

          $scope.numberFilter = {
            key: '=',
            value: 0,
          };

          $scope.textFilters = [
            { key: 'Exatamente', value: 0 },
            { key: 'Contendo', value: 1 },
          ];

          $scope.textFilter = { key: 'Exatamente', value: 0 };

          $scope.dateFilters = [
            {
              key: 'Hoje',
              value: 0,
            },
            {
              key: '1 semana atrás',
              value: 1,
            },
            {
              key: '1 mês atrás',
              value: 2,
            },
            {
              key: 'Entre datas',
              value: 3,
            },
          ];

          $scope.dateFilter = {
            key: 'Hoje',
            value: 0,
          };

          $scope.startDate;
          $scope.endDate;
          $scope.listOptions = [];
          $scope.filterByUser = false;
          $scope.filterByDate = false;
          $scope.filterByRepository = false;
          $scope.selectedUser;
          $scope.selectedRepository;
          $scope.users = [];
          $scope.repositories = [];

          $scope.loadUsers = logWrapper(
            loadUsers,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadRepositories = logWrapper(
            loadRepositories,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.isDateField = logWrapper(
            isDateField,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.showUsersField = logWrapper(
            showUsersField,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.isBetweenDates = logWrapper(
            isBetweenDates,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.isListField = logWrapper(
            isListField,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.formatedDate = logWrapper(
            formatedDate,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getIcon = logWrapper(
            getIcon,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.formatedSize = logWrapper(
            formatedSize,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.formatedDocumentType = logWrapper(
            formatedDocumentType,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.formatedTitle = logWrapper(
            formatedTitle,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.truncateText = logWrapper(
            truncateText,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.formatedDescription = logWrapper(
            formatedDescription,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.sortColumn = logWrapper(
            sortColumn,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.saveAsPdf = logWrapper(
            saveAsPdf,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.onSelectUser = logWrapper(
            onSelectUser,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.onSelectRepository = logWrapper(
            onSelectRepository,
            runtimeConstant.isDebugControllersInternals
          );

          $rootScope.$broadcast('clearSearchTerm');

          $scope.imageTypes = ['png', 'gif', 'jpeg', 'jpg', 'bmp'];

          $scope.title = '';
          $scope.description = '';
          $scope.searchTerm = '';

          $scope.columns = [
            {
              id: 'folder',
              //width: '80',
              header: $filter('translate')('COLUMN.FOLDER'),
              expression: 'FolderName',
              sortExpression: 'FolderName',
              style: {
                'min-width': '80px',
              },
              mobileShow: false,
              visible: true,
              dataPriority: 3,
              sortable: true,
              disabled: false,
              type: 'text',
            },
            {
              id: 'code',
              //width: '75',
              header: $filter('translate')('COLUMN.CODE'),
              style: {
                'min-width': '40px',
              },
              expression: 'Code',
              sortExpression: 'Code',
              mobileShow: false,
              dataPriority: 3,
              visible: true,
              disabled: false,
              sortable: true,
              type: 'text',
            },
            {
              id: 'title',
              width: '35%',
              header: $filter('translate')('COLUMN.TITLE'),
              expression: 'Title',
              style: {
                'min-width': '150px',
              },
              sortExpression: 'Title',
              tooltip: 'tooltipTitle()',
              dataPriority: 1,
              visible: true,
              disabled: false,
              sortable: true,
              type: 'text',
            },
            {
              id: 'author',
              //width: '25%',
              header: $filter('translate')('COLUMN.AUTHOR'),
              expression: 'AuthorName',
              style: {
                'min-width': '80px',
              },
              mobileShow: false,
              visible: true,
              dataPriority: 6,
              disabled: false,
              sortable: true,
              type: 'text',
            },
          ];

          if ($state.params.id) {
            $scope.idfolder = parseInt($state.params.id);
          }

          $scope.noDocuments = $scope.idfolder
            ? $filter('translate')('NO DOCUMENTS')
            : $filter('translate')('NO FOLDER SELECTED');

          $scope.noDocumentsMessage = $scope.idfolder
            ? $filter('translate')('NO DOCUMENTS MSG')
            : $filter('translate')('NO FOLDER SELECTED MSG');

          $scope.groups = null;

          $scope.loadUsers();
          $scope.loadRepositories();
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
